<figure class="m-0" id="bar-chart"></figure>